<template>
  <confirm-notification
    v-if="!!show"
    :activator="!!show"
    :notification="currentNotification"
    @close="show = false"
  >
  </confirm-notification>
</template>
<script>
import ConfirmNotification from "@/components/general/ConfirmNotification.vue";
export default {
  name: "NotificationsToConfirm",
  components: {
    ConfirmNotification,
  },
  data() {
    return {
      show: null,
    };
  },
  computed: {
    // notificationsToConfirm() {
    //   return this.$store.getters["notifications/confirmations"];
    // },
    // hasNotificationsToConfirm() {
    //   console.log(
    //     "hasNotificationsToConfirm",
    //     Object.keys(this.notificationsToConfirm).length
    //   );
    //   return Object.keys(this.notificationsToConfirm).length > 0;
    // },
    currentNotification() {
      return this.$store.getters["notifications/firstConfirmation"];
    },
    // currentNotification() {
    //   return this.hasNotificationsToConfirm
    //     ? Object.values(this.notificationsToConfirm)[0]
    //     : null;
    // },
  },
  watch: {
    currentNotification: {
      handler(newNotification, oldNotification) {
        if (
          newNotification &&
          (!oldNotification || newNotification.slug !== oldNotification.slug)
        ) {
          this.show = false;
          this.$nextTick(() => {
            this.show = true;
          });
        }
      },
      deep: true,
    },
  },
};
</script>
